
import { createAction } from 'typesafe-actions';
import { IFlowmeter } from '../../@types/model/flowmeter/flowmeter';

export const flowmeterSetList = createAction('FLOWMETER_SET_PUMPINGSTATIONS', resolve => (flowmeters : Array<IFlowmeter>) => resolve(flowmeters));
export const flowmeterSetSelected = createAction('FLOWMETER_SET_SELECTED', resolve => (selectedFlowmeter ?: IFlowmeter) => resolve(selectedFlowmeter));
export const flowmeterSetLoading = createAction('FLOWMETER_SET_LOADING', resolve => (loading : boolean) => resolve(loading));
